<template>
  <div v-if="game.result === undefined || game.result === '*' || game.all === 'true' || game.broadcast === 'true'" id="{{game._id}}-middlesmall" :class="turnSmall">
    <div id="{{game._id ? game._id:game.id}}-boardsmall" style="width:100%; height:170px;" :class="classboard">
    </div>
  </div>
  <div v-else id="{{game._id ? game._id:game.id}}-middlesmall" style="" :class="turnSmall">
    <div id="{{game._id ? game._id:game.id}}-boardsmall" style="width:100%; height:170px;" :class="classboard">
    </div>
    <div class="resultevents" id="{{game._id ? game._id:game.id}}-imagesmall" style="width:170px; height:70px;">
      <span class="">{{ game.result }}</span>
    </div>
  </div>
</template>
<script>
// import Chess from 'chess.js'
import UserService from '../../services/user'
import Store from '../../services/lstorage'
// import Chessground from 'chessground'
// import Garbochess from '../../services/garbochess.js'
// import UserService from '../../services/user'
// import BoardHistory from '../game/boardHistory'
// import toast from 'vue-material-components'
// import Jquery from 'jquery'
// var intervalSmall = []
var stylesBoard = {
  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
}
export default {
  name: 'BoardVisorSmallEvents',
  props: {
    game: {
      type: Object
    },
    classboard: {
      type: String
    }
  },
  data () {
    return {
      // chess: new Chess(),
      styleboard: true,
      stylesBoard: stylesBoard,
      styles: Store.get('styleBoard',
        {
          board: 0,
          pieces: 0
        }),
      user: UserService.user,
      turnSmall: 'borderWhite'
    }
  },
  components: {
  },
  mixins: [
    // toast
  ],
  events: {
    updateBoard (board) {
      if (this.game._id === board._id) {
        var diff = this.getDifference(board.pgn, this.game.pgn)
        if (diff.length > 0) {
          // window.alert(board.pgn)
          this.loadDataGame(board)
          this.game = this.clone(board)
        }
      }
    }/* ,
    move (board) {
      if (this.game !== undefined && this.game._id === board.idBoard) {
        // board.pgn = board.pgn.split('"]').join('"]\n')
        // board.pgn = board.pgn.split('{}').join('')
        this.changeStateGame(board.pgn, board.idBoard, board.fen)
      }
    }*/
  },
  methods: {
    clone (obj) {
      var dupe = (obj instanceof Array) ? [] : {}
      for (var property in obj) {
        if (typeof property === 'object') {
          dupe[property] = this.clone(obj[property])
        } else {
          dupe[property] = obj[property]
        }
      }
      return dupe
    },
    getDifference (string1, string2) {
      const differences = []
      const maxLength = Math.max(string1.length, string2.length)
      for (let i = 0; i < maxLength; i++) {
        const char1 = string1[i] || '' // Si falta el carácter, usa cadena vacía
        const char2 = string2[i] || '' // Si falta el carácter, usa cadena vacía
        if (char1 !== char2) {
          differences.push({
            position: i,
            char1: char1 || '∅', // Marca con ∅ si no existe en la cadena original
            char2: char2 || '∅'  // Marca con ∅ si no existe en la cadena comparada
          })
        }
      }
      return differences
    },
    deleteComment (pgn) {
      // pgn = pgn.replace(/\{(.*?)\}/gmu, '')
      pgn = pgn.replace(/\{\[%emt(\s\S.+?)\]\}/gmu, '')
      pgn = pgn.replace('\r\n\r\n', '\n')
      // pgn = pgn.replace(/\{(\s\S.+?)\}/gmu, '')
      return pgn
    },
    hasBody (pgn) {
      var ret = false
      var newlineChar = '\r?\n'
      var lines = pgn.split(new RegExp(newlineChar))
      for (var i = 0; i < lines.length; i++) {
        // window.alert(lines[i])
        var linea = lines[i].trim()
        if (linea.length > 0 && linea[0] !== '['/* && lines[i].includes('.') */ && linea[0] !== '*') {
          // window.alert(linea)
          ret = true
          break
        }
      }
      return ret
    },
    parse_pgn_header (header) {
      var newlineChar = '\r?\n'
      var headerObj = {}
      var headers = header.split(new RegExp(newlineChar))
      var key = ''
      var value = ''
      for (var i = 0; i < headers.length; i++) {
        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1')
        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1')
        if (key.length > 0 && value.length > 0 && key !== value) {
          headerObj[key] = value
        }
      }
      return headerObj
    },
    changeStateGame (pgn, id, fen) {
      if (document.getElementById(id + '-middlesmall') !== null) {
        // window.alert('changeStateGame')
        if (this.game.result === undefined || this.game.result === '*' || this.game.result !== '*' || this.game.all === 'true' || this.game.broadcast === 'true') {
          var Width = 170// document.getElementById(id + '-middlesmall').clientWidth
          var pos = 'end'
          var start = fen !== undefined ? fen : ''
          var pgnBoard = 0
          // pgn = this.deleteComment(pgn)
          // pgn = pgn.split('"]').join('"]\n')
          // pgn = pgn.split('{}').join('')
          // window.alert(pgn)
          var headers = this.parse_pgn_header(pgn)
          if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
            pos = fen !== undefined ? fen : 'end'
            if (!this.hasBody(pgn)) {
              start = ''
              pos = headers['FEN']
            }
            if (pos === headers['FEN']) {
              start = ''
            }
          }
          if (start === 'start' || start === 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1') {
            start = ''
            pos = fen
          }
          if (start === headers['FEN']) {
            start = ''
          }
          try {
            if (Width > 0 && pgn !== 'none' && pgn !== '' && typeof window.pgnView === 'function' && this.hasBody(pgn)) {
              // window.alert('[FEN]' + fen)
              pgnBoard = window.pgnView({inner: id + '-boardsmall'}, {pgn: pgn, startPlay: start, position: pos, showCoords: false, width: Width}) // , orientation: (this.turnSmall === 'w') ? 'white' : 'black'})
            } else {
              pgnBoard = window.pgnView({inner: id + '-boardsmall'}, {pgn: '', position: '', showCoords: false, width: Width}) // , orientation: (this.turnSmall === 'w') ? 'white' : 'black'})
            }
            // this.turnSmall = pgnBoard.chess.turn() === 'w' ? 'borderWhite' : 'borderBlack'
            if (pgnBoard && pgnBoard.chess) {
              this.turnSmall = pgnBoard.chess.turn() === 'w' ? 'borderWhite' : 'borderBlack'
            }
            const comments = document.querySelectorAll('.afterComment')
            comments.forEach((comment) => {
              // Verifica si el texto del comentario contiene el emoji 🎥
              const textResource = comment.textContent.toLowerCase()
              if (textResource.includes('🎥') || textResource.includes('vídeo') || textResource.includes('recurso') || textResource.includes('video')) {
                // Añade la clase .highlight-move al elemento padre con clase .move
                comment.closest('.move').classList.add('highlight-move')
              }
            })
          } catch (error) {
            console.error('<span>' + 'Error Mainchess (changeStateGame): ' + error + '</span>', 3000)
          }
        }
      }
    },
    loadDataGame (board) {
      // window.alert('loadDataGame')
      this.changeStateGame(board.pgn, board._id ? board._id : board.id, 'end')
    }
  },
  watch: {
    game (newVal, oldVal) {
      // this.loadDataGame(newVal, true)
      if (newVal.pgn !== oldVal.pgn) {
        // window.alert('game')
        this.loadDataGame(newVal)
      }
    }
  },
  beforeDestroy () {
    if (this.game !== undefined) {
      this.game._id = this.game._id ? this.game._id : this.game.id
    }
    // clearInterval(intervalSmall[this.game._id])
  },
  beforeCreate () {
    // console.log('beforeCreate')
  },
  created () {
    // window.alert('created')
    this.game._id = this.game._id ? this.game._id : this.game.id
    // window.alert(this.game._id + gameActualEvents[this.game._id])
    // this.loadDataGame(this.game, true)
    setTimeout(function () {
      if (this.game !== undefined) {
        // this.gameActual[this.game._id] = this.game
        // window.alert(window.gameActualEvents.length)
        this.game._id = this.game._id ? this.game._id : this.game.id
        this.loadDataGame(this.game)
      }
    }.bind(this), 50)
  },
  init () {
    // console.log('init')
  },
  updated () {
    // console.log('updated')
  },
  destroyed () {
    // console.log('beforeDestroy')
  }
  /* compiled () {
    // console.log('compiled')
  }*/
}
</script>

<style scoped>
/* @import '../../../static/libs/simplechessboard.min.css';*/
.userTurn {
  color: white ;
  font-size: large;
}
.borderWhite {
  border: 7px solid white;
}
.borderBlack {
  border: 7px solid black;
}
.check {
  background: radial-gradient(ellipse at center, rgb(123, 255, 0) 40%, rgba(231, 0, 0, 1) 40%, rgba(169, 0, 0, 0) 89%, rgba(158, 0, 0, 0) 100%);
}
.resultevents {
  margin: auto;
  width: 100%;
  padding: 10px;
  background: darkgray;
  opacity: 0.8;
  top: 60px;
  position: absolute;
  font-size: xx-large;
  font-style: bold;
  color: black;
  text-align: center;
  z-index: 200;
}

</style>



// WEBPACK FOOTER //
// boardVisorSmallEvents.vue?87b5e8b8